// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"0":"ddcd09ed","14":"e267a43e","147":"fee24d60","374":"52762c03","379":"b75e0d90","389":"a8a60fa7","528":"afa27699","557":"c0451362","718":"bd498646","926":"5c11806e"}[chunkId] + ".js";
};